import { signal, WritableSignal } from "@angular/core";
import { AppAvailabilityDto, Key } from "@app/core";



export class AppAvailability
{
  public catalog: WritableSignal<boolean>;
  public library: WritableSignal<boolean>;

  @Key('service-matrix')
  public servicesMatrix: WritableSignal<boolean>;

  @Key('space-bot')
  public spaceBot: WritableSignal<boolean>;
  public security: WritableSignal<boolean>;
  public tracker: WritableSignal<boolean>;
  public marketplace: WritableSignal<boolean>;
  public monitoring: WritableSignal<boolean>;

  constructor()
  {
    this.catalog = signal<boolean>(false);
    this.library = signal<boolean>(false);
    this.servicesMatrix = signal<boolean>(false);
    this.spaceBot = signal<boolean>(false);
    this.security = signal<boolean>(false);
    this.tracker = signal<boolean>(false);
    this.marketplace = signal<boolean>(false);
    this.monitoring = signal<boolean>(false);
  }

  public static fromDto(dto: AppAvailabilityDto)
  {
    const app = new AppAvailability();
    app.catalog.set(dto.catalog);
    app.library.set(dto.library);
    app.servicesMatrix.set(dto.servicesMatrix);
    app.spaceBot.set(dto.spaceBot);
    app.security.set(dto.management)
    app.tracker.set(dto.tracker);
    app.marketplace.set(dto.marketplace);
    app.monitoring.set(dto.monitoring);
    return app;
  }

}